import TransactionTemplateRow from './TransactionTemplateRow';

export default TransactionTemplateRow;
